/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useRef } from 'react';
import { COURSE_STATUS_COMPLETE, COURSE_TYPE, DATE_YMD, DATE_YMD_ISO, LEVEL_COURSE_STRING, SCREEN_MODE, TRAINING_COURSE_SETTINGS_STATUS, TRAINING_COURSE_SETTINGS_TYPE } from '../../../core/configs/constants';

import classNames from 'classnames';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useStore } from '../../../core/utils/hook';
import SettingReportModal from '../../TrainingCourse/modals/SettingReportModal';
import SettingQuestionModal from '../../TrainingCourse/modals/SettingQuestionModal';
import { formatScheduledPublishDateJP, isPublicDateAfterTodayJP } from '../../../core/utils/common';

const TrainingCourseSlideComponent = observer(({ slides, hideNavigation = false, shrinkToContent = false }) => {
    // other
    const navigate = useNavigate();

    // store
    const { modalStore: { show, hide }, courseStore: { getTrainingCourseList } } = useStore();

    // ref
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    return (
        <div>
            <Swiper
                direction='horizontal'
                modules={[Navigation]}
                navigation={!hideNavigation ? {
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                } : false}
                onInit={(swiper) => {
                    setTimeout(() => {
                        if (swiper.params?.navigation) {
                            if (typeof swiper.params.navigation !== 'boolean') {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }
                        }
                    });
                }}
                slidesPerView='auto'
                spaceBetween={20}
                breakpoints={{
                    0: { spaceBetween: 10 },
                    481: { spaceBetween: 20 }
                }}
                allowTouchMove={true}
                className={classNames('carousel-course-training-container', shrinkToContent && 'shrink-to-content')}
            >
                {slides.map((slide) => {
                    const courseDetail = slide;
                    
                    const status = courseDetail?.statusUserCourse;
                    let color = '';
                    let statusText = '';
                    const isActive = isPublicDateAfterTodayJP(courseDetail?.publicDate);
                    switch (status) {
                    case COURSE_STATUS_COMPLETE.USER_COURSE_NOT_ATTENDED: // 0
                    case COURSE_STATUS_COMPLETE.USER_COURSE_ATTENDING: // 1
                    case COURSE_STATUS_COMPLETE.USER_COURSE_NOT_DO_TEST: // 2
                        color = '#F0AE00';
                        statusText = '受講中';
                        break;
                    case COURSE_STATUS_COMPLETE.USER_COURSE_APPLY_CERTIFICATE: // 3
                        color = '#00A50B';
                        statusText = '受講完了';
                        break;
                    default:
                        color = '#000000';
                        statusText = '未受講';
                        break;
                    }

                    const handleShowModalSettingReport = (id, name, submitReportDeadline, mode, reportContent) => {
                        show({
                            id: 'modal-setting-submit-report-training-course',
                            isOpen: true,
                            header: '提出物アップロード',
                            onCancel: () => hide(),
                            children: (
                                <SettingReportModal mode={mode} id={id} name={name}
                                    deadline={submitReportDeadline} fetchData={() => getTrainingCourseList({ isHomeList: true })} reportContent={reportContent} readOnly={mode === SCREEN_MODE.VIEW} />
                            ),
                            type: 'medium width-750 responsive-modal'
                        })
                    }
                
                    const handleShowModalSettingQuestion = (mode) => {
                        show({
                            id: 'modal-setting-submit-question-training-course',
                            isOpen: true,
                            header: mode === SCREEN_MODE.ADD ? '質問する' : '質問',
                            onCancel: () => hide(),
                            children: (
                                <SettingQuestionModal mode={SCREEN_MODE.EDIT} id={slide.id} name={slide.name}
                                    deadline={slide.submitReportDeadline} fetchData={() => getTrainingCourseList({ isHomeList: true })} />
                            ),
                            type: 'medium width-750 responsive-modal'
                        })
                    }

                    return (
                        <SwiperSlide key={slide.id}>
                            <div className={`slide-content ${isActive ? 'has-overlay' : ''}`}>
                                <div 
                                    className={`slide-content-header ${!isActive ? 'cursor-pointer' : ''}`}
                                    onClick={() => {
                                        if (isActive) return;
                                        navigate(`/course/${slide.id}`);
                                    }}>
                                    <div className='slide-content-thumbnail'>
                                        <img src={slide?.thumbnail || '/images/img-1.png'} alt='' />
                                    </div>
                                    <div className='slide-content-title line-clamp-2'>{slide?.name}</div>
                                </div>
                                <div className='slide-content-info'>
                                    <div className='slide-content-info-item slide-content-status'>
                                        <div className='title'>受講状況</div>
                                        <div className='content' style={{ color: color }}>{statusText}</div>
                                    </div>
                                    <div className='slide-content-info-item slide-content-progress'>
                                        <div className='title'>進捗</div>
                                        <div className='content' style={{ color: color }}>{Object.values(COURSE_STATUS_COMPLETE).includes(slide.statusUserCourse) ? `${(slide.statusUserCourse == null) ? 0 : (slide.totalTimeJoinCourse/slide.totalTimeCourse*100).toFixed(0)}%` : '--'}</div>
                                    </div>
                                    {
                                        slide.statusUserCourse === COURSE_STATUS_COMPLETE.USER_COURSE_APPLY_CERTIFICATE ? (
                                            <>
                                                {
                                                    slide?.submitReportStatus === TRAINING_COURSE_SETTINGS_STATUS.ON && slide?.statusUserCourse === COURSE_STATUS_COMPLETE.USER_COURSE_APPLY_CERTIFICATE ? (
                                                        <div className='slide-content-info-item slide-content-report'>
                                                            <div className='title'>
                                                                <span>レポート</span>
                                                                {
                                                                    !slide?.reportContent && (
                                                                        <img
                                                                            data-bs-toggle="tooltip" 
                                                                            data-bs-placement="top" 
                                                                            title={`提出期限: ${moment(slide?.completionDate).add(slide?.submitReportDuration, slide?.submitReportType === TRAINING_COURSE_SETTINGS_TYPE.DAY ? 'days' : 'months').format(DATE_YMD)}`}
                                                                            src='/images/icon-i-2.svg' alt='' />
                                                                    )
                                                                }
                                                            </div>
                                                            {
                                                                slide?.reportContent != null ? (
                                                                    slide?.submitReportDeadline && moment(slide.submitReportDeadline).isSameOrAfter(moment().format(DATE_YMD_ISO)) && !slide?.isDownloaded ? (
                                                                        <div
                                                                            onClick={() => handleShowModalSettingReport(slide.id, slide.name, slide.submitReportDeadline, SCREEN_MODE.EDIT, slide?.reportContent)}
                                                                            className='content text-link text-hover-underline cursor-pointer'>修正する</div>
                                                                    ):
                                                                        <div
                                                                            onClick={() => handleShowModalSettingReport(slide.id, slide.name, slide.submitReportDeadline, SCREEN_MODE.VIEW, slide?.reportContent)}
                                                                            className='content text-link text-hover-underline cursor-pointer'>提出済</div>
                                                                ) : (
                                                                    slide?.submitReportDeadline && moment(slide.submitReportDeadline).isSameOrAfter(moment().format(DATE_YMD_ISO)) ? (
                                                                        <div
                                                                            onClick={() => handleShowModalSettingReport(slide.id, slide.name, slide.submitReportDeadline, SCREEN_MODE.ADD)}
                                                                            className='content text-link text-hover-underline cursor-pointer'>提出する</div>
                                                                    ) : (
                                                                        <div className='content text-danger' style={{ fontWeight: '500', fontSize: '14px' }}>期限切れ</div>
                                                                    )
                                                                )
                                                            }
                                                            
                                                        </div>
                                                    ) : (<div></div>)
                                                }

                                                {
                                                    slide?.submitQuestionStatus === TRAINING_COURSE_SETTINGS_STATUS.ON && slide?.statusUserCourse === COURSE_STATUS_COMPLETE.USER_COURSE_APPLY_CERTIFICATE && (
                                                        <div className='slide-content-info-item slide-content-report'>
                                                            <div className='title'>
                                                                <span>質問</span>
                                                                {
                                                                    !slide?.question && (
                                                                        <img
                                                                            data-bs-toggle="tooltip" 
                                                                            data-bs-placement="top" 
                                                                            title={`質問可能な期限: ${moment(slide?.completionDate).add(slide?.submitQuestionDuration, slide?.submitQuestionType === TRAINING_COURSE_SETTINGS_TYPE.DAY ? 'days' : 'months').format(DATE_YMD)}`}
                                                                            src='/images/icon-i-2.svg' alt='' />
                                                                    )
                                                                }
                                                            </div>
                                                            {
                                                                slide?.question ? (
                                                                    <div className='content' style={{ fontWeight: '600', color: '#00A50B', fontSize: '14px' }}>質問済</div>
                                                                ) : (
                                                                    slide?.submitQuestionDeadline && moment(slide.submitQuestionDeadline).isSameOrAfter(moment().format(DATE_YMD_ISO)) ? (
                                                                        <div
                                                                            onClick={() => handleShowModalSettingQuestion(SCREEN_MODE.ADD)}
                                                                            className='content text-link text-hover-underline cursor-pointer'>質問する</div>
                                                                    ) : (
                                                                        <div className='content text-danger' style={{ fontWeight: '500', fontSize: '14px' }}>期限切れ</div>
                                                                    )
                                                                )
                                                            }
                                                            
                                                        </div>
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <div className='slide-content-info-item slide-content-deadline'>
                                                <div className='title'>受講期限</div>
                                                <div className='content'>
                                                    <span className='content-deadline-date'>{`${slide?.incentivePeriod ? moment(slide.incentivePeriod).format(DATE_YMD) : (
                                                        slide?.deadline ? moment(slide.deadline).format(DATE_YMD) : <></>
                                                    )}`}</span>
                                                    {
                                                        slide?.incentivePeriod ? (() => {
                                                            const today = moment().startOf('day');
                                                            const target = moment(slide.incentivePeriod).startOf('day');
                                                            const remainingDays = target.diff(today, 'days');
                                                            return remainingDays <= 30 && remainingDays >= 0 ? (
                                                                <span className='content-deadline-remaining'>{`(あと${remainingDays}日)`}</span>
                                                            ) : <></>;
                                                        }) : (
                                                            slide?.deadline && (() => {
                                                                const today = moment().startOf('day');
                                                                const target = moment(slide.deadline).startOf('day');
                                                                const remainingDays = target.diff(today, 'days');
                                                                return remainingDays <= 30 && remainingDays >= 0 ? (
                                                                    <span className='content-deadline-remaining'>{`(あと${remainingDays}日)`}</span>
                                                                ) : (remainingDays < 0 ? (<span style={{ fontSize: '12px', color: '#EB0000' }}> (期限切れ)</span>) : <></>);
                                                            })
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                {isActive && (
                                    <div className='slide-content-warning'>

                                        <span style={{
                                            backgroundColor: 'rgba(235, 0, 0, 0.1)',
                                            padding: '5px 5px'
                                        }}>{formatScheduledPublishDateJP(courseDetail?.publicDate)}</span>
                                    </div>
                                )}
                                
                            </div>
                            
                        </SwiperSlide>
                    )
                })}
                {
                    !hideNavigation && (
                        <div className='slide-button-container'>
                            <div ref={prevRef} className={classNames('flex-none cursor-pointer')}>
                                <img src='/images/icon-button-left.svg' style={{ height: '33px', width: '33px' }} />
                            </div>
                            <div ref={nextRef} className={classNames('flex-none cursor-pointer')}>
                                <img src='/images/icon-button-right.svg' style={{ height: '33px', width: '33px' }} />
                            </div>
                        </div>
                    )
                }
            </Swiper>
        </div>
    )
});

export default TrainingCourseSlideComponent;
